import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import Header from './header';
import Footer from './footer';
import './layout.css';

function Layout({ children, subtitle, className = '' }) {
  return (
    <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={(data) => (
        <div className="wrapper">
          <Helmet
            title={`${data.site.siteMetadata.title} - ${subtitle}`}
            meta={[
              {
                name: 'description',
                content:
                  'Manufacturer of electrical distribution equipment with power metering and remote control using DMX, sACN, BACnet, and other commercial protocols.  Located in Los Angeles, CA.',
              },
            ]}
          >
            <html lang="en" className={`smart-power ${className}`} />
            <style>
              @import
              url('https://fonts.googleapis.com/css2?family=Spartan&display=swap');
            </style>
            <link
              rel="stylesheet"
              type="text/css"
              charset="UTF-8"
              href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
            />
            <link
              rel="stylesheet"
              type="text/css"
              href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
            />
          </Helmet>
          <Header siteTitle={data.site.siteMetadata.title} />
          <main>{children}</main>
          <Footer />
        </div>
      )}
    />
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
